import { reactive, ref } from 'vue';

export interface SharingSignUpForm {
  firstname: string;
  lastname: string;
  email: string;
  phoneNumber: string;
  criteria: string | string[] | null;
  chosenTouchpoints: number[];
  touchpoints: Record<string, string>;
  consent: boolean | undefined;
}

export interface SharingFormData {
  selectedCampaign: string | null;
  signUp: SharingSignUpForm;
}

const createInitialSignUp = (): SharingSignUpForm => ({
  firstname: '',
  lastname: '',
  email: '',
  phoneNumber: '',
  criteria: null,
  chosenTouchpoints: [],
  touchpoints: {},
  consent: undefined,
});

export const useSharingForm = () => {
  const formData = reactive<SharingFormData>({
    selectedCampaign: null,
    signUp: createInitialSignUp(),
  });

  const disableBtn = ref(false);
  const duplicateHelpeeMsg = ref<string | undefined>(undefined);

  const resetForm = () => {
    formData.selectedCampaign = null;
    Object.assign(formData.signUp, createInitialSignUp());
  };

  const resetCampaignFields = () => {
    formData.signUp.criteria = null;
    formData.signUp.chosenTouchpoints = [];
    formData.signUp.touchpoints = {};
  };

  const clearDuplicateState = () => {
    duplicateHelpeeMsg.value = undefined;
    disableBtn.value = false;
  };

  return {
    formData,
    disableBtn,
    duplicateHelpeeMsg,
    resetForm,
    resetCampaignFields,
    clearDuplicateState,
  };
};
